module.exports = __webpack_public_path__ + "img/niu1.77aea331.jpg";